import React from 'react';
import PropTypes from 'prop-types';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

const styles = () => ({
  root: {},
});

const LinkedAccountErrorDetailsLayout = ({ classes }) => {
  return (
    <div className={classes.root}>
      <MetaField attr="financialInstitutionId" />
      <MetaField attr="lastSynced" />
      <MetaField attr="yodleeLoginName" />
      <MetaField attr="finicityCustomerId" />
      <MetaField attr="connectionID" />
      <MetaField attr="fixableWithLogin" />
      <MetaField attr="description" />
    </div>
  );
};

LinkedAccountErrorDetailsLayout.defaultProps = {
};

LinkedAccountErrorDetailsLayout.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(LinkedAccountErrorDetailsLayout);
